import { Skeleton } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

import type { FeatureKey } from '@/core/authz/entitlement-catalog';
import { UpgradeCard } from '@/core/components/billing/upgrade-surfaces';
import { useEntitlements } from '@/core/hooks/use-entitlements';

type FeatureGateProps = {
  children: ReactNode;
  feature: FeatureKey;
  fallback?: ReactNode;
};

export function FeatureGate({ children, feature, fallback }: FeatureGateProps) {
  const { isFeatureEnabled, isLoading } = useEntitlements();

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-5 w-1/3" />
        <Skeleton className="h-20 w-full" />
      </div>
    );
  }

  if (!isFeatureEnabled(feature)) {
    return <>{fallback ?? <UpgradeCard feature={feature} compact />}</>;
  }

  return <>{children}</>;
}
